export const maybePluralize = (
  length: number,
  singular: string,
  plural: string = singular + "s",
): string => {
  return length === 1 ? singular : plural;
};

export const maybePluralizePhrase = (
  length: number,
  singular: string,
  plural?: string,
): string => {
  return `${length} ${maybePluralize(length, singular, plural)}`;
};

export const wrapWithXmlTag = (
  tagTemplate: TemplateStringsArray,
  ..._: never[]
): ((content: string) => string) => {
  return (content: string) =>
    `<${tagTemplate.join("")}>\n${content.trim()}\n</${tagTemplate.join("")}>`;
};
